import type { Maybe } from '@adornis/base/utilTypes.js';
import { Int } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';

export const PersonenGruppe = {
  0: 'keine Angabe',
  101: 'sozialversicherungspflichtig Beschäftigte ohne besondere Merkmale',
  102: 'Auszubildende',
  103: 'Beschäftigte in Altersteilzeit',
  104: 'Hausgewerbetreibende',
  105: 'Praktikanten',
  106: 'Werkstudenten',
  107: 'Personen in Einrichtungen der Jugendhilfe oder Werkstätten für Behinderte',
  108: 'Bezieher von Vorruhestandsgeld',
  109: 'geringfügig entlohnte Beschäftigte nach § 8 Abs. 1 Nr.1 SGB IV',
  110: 'kurzfristig Beschäftigte nach § 8 Abs.1 Nr.2 SGB IV',
  111: 'Personen in berufsfördernden Maßnahmen zur Rehabilitation',
  112: 'Mitarbeitende Familienangehörige in der Landwirtschaft',
  113: 'Nebenerwerbslandwirte',
  114: 'Nebenerwerbslandwirte - saisonal beschäftigt',
  116: 'Ausgleichsgeldempfänger nach dem FELEG',
  118: 'berufsmäßig unständig Beschäftigte',
  119: 'versicherungsfreie Altersvollrentner und Versorgungsbezieher wegen Alters',
  120: 'Versicherungspflichtige Altersvollrentner und Versorgungsbezieher wegen Alters',
  121: 'Auszubildende, deren Arbeitsentgelt die Geringverdienergrenze nach § 20 Absatz 3 Satz 1   Nummer 1 SGB IV nicht übersteigt. Bitte beachten Sie auch die notwendige   Eintragung 1 in der Ergänzung SV-Pflicht (502992). Der Personengruppenschlüssel ist selbst dann anzuwenden, wenn die Geringverdienergrenze infolge einmalig gezahlten Arbeitsentgelts überschritten wird.',
  123: 'Personen, die ein freiwilliges soziales, ein freiwilliges ökologisches Jahr oder einen   Bundesfreiwilligendienst leisten. Bitte beachten Sie dazu auch die notwendige   Eintragung 9 in der Ergänzung SV-Pflicht (502992).',
  140: 'Seeleute',
  141: 'Auszubildende in der Seefahrt',
  142: 'Seeleute in Altersteilzeit',
  143: 'Seelotsen',
  144: 'Auszubildende in der Seefahrt, deren Arbeitsentgelt die Geringverdienergrenze nach § 20 Absatz 3 Satz 1   Nummer 1 SGB IV nicht übersteigt. Bitte beachten Sie auch die notwendige Eintragung 1 in der Ergänzung SV-Pflicht (502992). Der Personengruppenschlüssel ist selbst dann anzuwenden, wenn die Geringverdienergrenze infolge einmalig gezahlten Arbeitsentgelts überschritten wird.',
  149: 'In der Seefahrt beschäftigte versicherungsfreie Altersvollrentner und Versorgungsbezugsempfänger wegen Alters.',
  150: 'In der Seefahrt beschäftigte versicherungspflichtige Altersvollrentner und Versorgungsbezieher wegen Alters.',
  190: 'ausschließlich Beschäftigte im Sinne der Unfallversicherung. Der Beitragsgruppenschlüssel ist in diesen Fällen 0000. Beispiele: Privat Versicherte geringfügig Beschäftigte, die in einer Berufsständischen Versorgungseinrichtung versichert sind oder Studenten in einem vorgeschriebenen Zwischenpraktikum.',
  900: 'bis 999 Für nicht sozialversicherungspflichtige Personen kann hier ein anwenderindividueller   Schlüssel eingegeben werden.',
};

// We currently do not see the need to further abstract this. The last key, value is weird but it is only a single case in multiple years. We definitly need to rebuild this with more fields. if there are more weird cases in the future.
export enum Abrechnungsgruppe {
  ANGESTELLTE = 'Angestellte',
  HESS_LANDESBEAMTE = 'Hess. Landesbeamte',
  KRICHENBEAMTE = 'Kirchenbeamte',
  LANDESBEAMTE_RLP = 'Landesbeamte RLP',
  SONSTIGE = 'Sonstige Gestellung',
  ANGESTELLTE_UND_LANDESBEAMTER_RLP = 'Angestellte und Landesbeamte RLP',
  ANGESTELLTE_BISTUM = 'Angestellte Bistum',
  FSJ = 'FSJ',
  EVANGELISCHE_KIRCHE_HN = 'Evangel. Kirche HN',
}

/**
 * At the moment we do not have a complete set of contracts for kirchenbeamte or Landesbeamte RLP as they are not directly employeed. We hold critical Information in the contracts though, so we can just ignore the signature for now.
 * @param abrechnungsgruppe
 * @returns
 */
export function isBeamterAbrechnungsgruppe(abrechnungsgruppe: Maybe<Abrechnungsgruppe>): boolean {
  if (!abrechnungsgruppe) return false;
  return [Abrechnungsgruppe.LANDESBEAMTE_RLP, Abrechnungsgruppe.KRICHENBEAMTE].includes(abrechnungsgruppe);
}

@Entity()
export class ANBeschaeftigung extends AdornisEntity {
  static override _class = 'ANBeschaeftigung';

  @Field(type => String)
  employeeType: Maybe<string>;

  @Field(type => Int)
  personenGruppe: Maybe<number>;

  @Field(type => String)
  abrechnungsgruppe: Maybe<Abrechnungsgruppe>;

  // Soll kein Enum mit Fächern sein, weil es hier komplex werden könnte. (e.g. "Kunst, aber nur Sekundarstufe 1 und Mathe in der Oberstufe")
  @Field(type => String)
  fachrichtung: Maybe<string>;
}
